import React from 'react';

type LoginContentContainerProps = { children: React.ReactNode };

const LoginContentContainer = ({ children }: LoginContentContainerProps) => {
	return <div className="vtex-login-2-x-contentContainer contentContainer shadow-3 mt3">{children}</div>;
};

export default LoginContentContainer;
